const obj = {
  ID: '',
  ContratoID: '',
  Login: '',
  Senha: '',
  Nome: '',
  Email: '',
  Token: '',

  Perfil: '', //Perfis de usuário: admin, staff, controller
  PerfilProgramacao: '',

  //Validade do token
  ExpireIn: '',
  DataCreateToken: '',
  DataExpireToken: '',
}

export default function UserModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
